<template>
  <div>
    <v-dialog v-model="dialog" persistent>
      <v-card>
        <!-----------------------------------------TITLE BAR----------------------------------------->
        <v-card-title class="redColor d-flex">
          <!--TITLE-->
          <span class="headline">
            {{ $t("parts.inventory.edit_multiple") }}
          </span>

          <v-spacer />

          <!--CLOSE BUTTON-->
          <v-btn
            variant="outlined"
            icon
            size="small"
            color="black"
            @click="close"
          >
            <v-icon> mdi-close </v-icon>
          </v-btn>
        </v-card-title>
        <!-------------------------------------------FORM-------------------------------------------->
        <v-card-text>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-container grid-list-md>
              <v-col cols="12">
                <v-alert
                  :model-value="true"
                  variant="tonal"
                  border="bottom"
                  type="error"
                >
                  {{ $t("multiple_update") }}
                </v-alert>
              </v-col>
              <v-row wrap>
                <!--PRICE-->
                <v-col cols="6" xs="6" sm="4">
                  <v-text-field
                    v-model="price"
                    :disabled="
                      $store.getters.role === 'User' ||
                      $store.getters.role === 'EbayOperator'
                    "
                    :label="$t('parts.inventory.form.price')"
                    variant="outlined"
                    color="red-darken-1"
                    type="number"
                    step="0.01"
                    min="0"
                    oninput="validity.valid || (value = '')"
                  />
                </v-col>
                <!---------------------------------------BRAND--------------------------------------->
                <v-col cols="6" xs="12" sm="4" lg="4">
                  <v-text-field
                    v-model="brand"
                    :label="$t('parts.inventory.form.brand')"
                    color="red-darken-1"
                    variant="outlined"
                  />
                </v-col>
                <!---------------------------------------NOTES--------------------------------------->
                <v-col cols="12" xs="12" sm="4" lg="4">
                  <v-text-field
                    v-model="notes"
                    :label="$t('parts.inventory.form.notes')"
                    color="red-darken-1"
                    variant="outlined"
                    hide-details
                  />
                  <span
                    class="col-12 d-flex justify-end text-end ml-auto"
                    style="color: grey"
                    >{{
                      part.notes
                        ? "(" + part.notes.length + $t("characters") + ")"
                        : ""
                    }}</span
                  >
                </v-col>
                <!-------------------------------------WARRANTY-------------------------------------->
                <v-col cols="12" xs="12" sm="4">
                  <v-select
                    v-model="warranty_id"
                    :disabled="
                      $store.getters.role === 'User' ||
                      $store.getters.role === 'EbayOperator'
                    "
                    :items="warranties"
                    :label="$t('parts.inventory.form.warranty')"
                    color="red-darken-1"
                    variant="outlined"
                    :item-title="() => ''"
                    item-value="_id"
                    @update:model-value="onWarrantyChange"
                  >
                    <!-- Dropdown items -->
                    <template #item="{ props: itemProps, item }">
                      <v-list-item v-bind="itemProps">
                        {{ (item.raw.return_days ?? 0) / 86400 }}
                        {{ $t("warranties.days") }}
                      </v-list-item>
                    </template>

                    <!-- Selected value -->
                    <template #selection="{ item }">
                      <span v-if="item">
                        <!-- Find the selected warranty object -->
                        {{ (item.raw.return_days ?? 0) / 86400 }}
                        {{ $t("warranties.days") }}
                      </span>
                      <span v-else>
                        {{ $t("parts.inventory.form.warranty") }}
                      </span>
                    </template>
                  </v-select>
                </v-col>
                <!-------------------------------------EBAY CODE------------------------------------->
                <v-col cols="12" xs="12" sm="3" lg="4">
                  <v-text-field
                    v-model.trim="ebayCode"
                    :label="$t('parts.inventory.form.ebay_code')"
                    color="red-darken-1"
                    variant="outlined"
                  />
                </v-col>
                <!--------------------------------------QUALITY-------------------------------------->
                <v-col cols="12" xs="9">
                  <div class="subheading">
                    {{ $t("parts.inventory.form.quality") }}
                  </div>

                  <v-radio-group v-model="quality" inline>
                    <v-radio
                      v-for="(quality, index) in qualities"
                      :key="index"
                      :value="quality._id"
                      color="red-darken-2"
                    >
                      <template #label>
                        <v-rating
                          v-model="quality.rating"
                          color="amber"
                          small
                          background-color="amber"
                          readonly
                        />
                      </template>
                    </v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="red-darken-1" variant="outlined" @click="close">
            {{ $t("parts.inventory.form.close") }}
          </v-btn>
          <v-btn
            :disabled="!valid"
            :loading="loading"
            color="green-darken-1"
            variant="outlined"
            @click="save"
          >
            {{ $t("parts.inventory.form.save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="responseModal" max-width="500" permanent>
      <v-card>
        <v-card-text class="mb-0">
          <div v-for="(result, i) in dialogResults" :key="i">
            <p>
              <span v-if="result.updated">
                <v-alert
                  :value="true"
                  type="success"
                  variant="tonal"
                  border="bottom"
                >
                  {{ result.qrCode }} - {{ $t("multiple_update_success") }}
                </v-alert>
              </span>
              <span v-else>
                <v-alert
                  :value="true"
                  type="error"
                  variant="tonal"
                  border="bottom"
                >
                  {{ result.qrCode }} - {{ $t(result.reason) }}
                </v-alert>
              </span>
            </p>
            <v-divider v-if="i < dialogResults.length - 1" class="my-2" />
          </div>
        </v-card-text>
        <v-card-actions class="ml-auto text-end">
          <v-btn
            class="ml-auto"
            variant="outlined"
            @click="closeResponseModal()"
          >
            {{ $t("close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="limitModal" max-width="500">
      <v-alert v-model="alert.value" :type="alert.type">
        {{ $t(alert.message) }}
      </v-alert>
    </v-dialog>
  </div>
</template>

<script>
import getRequest from "../../api/getRequest";
import postRequest from "../../api/postRequest";

export default {
  components: {},
  props: ["hide"], // eslint-disable-line vue/require-prop-types
  data: () => ({
    valid: false,
    dialog: false,
    loading: false,
    part: {},
    currency: ["EUR"], // 'ALL'
    warranty_id: null,
    warranties: [],
    shipments: [],
    qualities: [],
    repositories: [],
    repository: {},
    room: {},
    location: {},
    pos_x: [],
    pos_y: [],
    position_x: null,
    position_y: null,
    price: null,
    ebayCode: "",
    shipment_id: "",
    notes: "",
    brand: "",
    quality: "",
    parts: [],
    alert: {
      value: false,
      type: "success",
      message: "",
    },
    ids: [],
    responseModal: false,
    limitModal: false,
    dialogResults: [],
  }),
  computed: {
    server() {
      return this.$serverUri;
    },
    role() {
      return this.$store.getters.role;
    },
    hideDialog() {
      return this.$props.hide;
    },
  },
  watch: {
    hideDialog(value) {
      if (value) {
        this.dialog = false;
      } else {
        this.dialog = true;
      }
    },
    dialog(value) {
      if (value) {
        this.getWarranties();
        this.getQualities();
      }
    },
  },
  methods: {
    openMultipleEdit(data) {
      this.parts = data;
      if (this.parts.length > 10) {
        this.limitModal = true;
        this.alert = {
          value: true,
          type: "error",
          message: "max_10_items",
        };
        setTimeout(() => {
          this.limitModal = false;
        }, 5000);
        return;
      }
      data.forEach((item) => {
        this.ids.push(item._id);
      });

      this.dialog = true;
    },
    close() {
      this.part = {};
      this.warranties = [];
      this.repositories = [];
      this.dialog = false;
      this.loading = false;
      this.price = null;
      this.brand = "";
      this.notes = "";
      this.quality = "";
      this.warranty_id = null;
      this.ebayCode = "";
      // this.$emit("close");
    },
    async save() {
      try {
        const data = {
          institution_id: this.$store.getters.institutionId,
          ids: this.ids,
          price: this.price,
          brand: this.brand,
          notes: this.notes,
          warranty_id: this.warranty_id,
          quality: this.quality,
          ebayCode: this.ebayCode,
        };
        const response = await postRequest.object("/part/edit-multiple", data);
        if (response && response.data && response.data.results) {
          this.dialogResults = response.data.results;
          this.responseModal = true;
        } else {
          this.alert = {
            value: true,
            type: "error",
            message: "Unexpected response from server",
          };
          this.responseModal = true;
        }
        this.close();
      } catch (error) {
        this.close();
      } finally {
        this.loading = false;
        this.$emit("close");
      }
    },
    closeResponseModal() {
      this.responseModal = false;
      this.dialogResults = [];
    },
    getWarranties() {
      getRequest("/warranty/")
        .then((response) => {
          this.warranties = response.warranties;
        })
        .catch(() => {});
    },
    getQualities() {
      getRequest("/quality/")
        .then((response) => {
          this.qualities = response.qualities;
        })
        .catch(() => {});
    },
    onWarrantyChange(value) {
      this.warranty_id = value;
    },
  },
};
</script>
